  document.addEventListener('DOMContentLoaded', function () {
    function setScrollClass(){
      // añade la clase si hay scroll, la quita si no
      document.documentElement.classList.toggle('is-scrolled', window.scrollY > 0);
    }
    setScrollClass(); // estado inicial
    window.addEventListener('scroll', setScrollClass, { passive: true });
  });